import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grid-type',
  templateUrl: './grid-type.component.html',
  styleUrls: ['./grid-type.component.scss']
})
export class GridTypeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
